// export const BASE_URL = "https://khaymatapi.mvp-apps.ae/";
export const BASE_URL = "https://kmzapi.rvamp.com/";

